/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_We_Work_Prepare_Item_1Inputs */

const en_how_we_work_prepare_item_1 = /** @type {(inputs: How_We_Work_Prepare_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A piece of work or a problem worth solving.`)
};

const lv_how_we_work_prepare_item_1 = /** @type {(inputs: How_We_Work_Prepare_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darbu vai problēmu, ko vērts atrisināt.`)
};

/**
* | output |
* | --- |
* | "A piece of work or a problem worth solving." |
*
* @param {How_We_Work_Prepare_Item_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const how_we_work_prepare_item_1 = /** @type {((inputs?: How_We_Work_Prepare_Item_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_We_Work_Prepare_Item_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_how_we_work_prepare_item_1(inputs)
	return en_how_we_work_prepare_item_1(inputs)
});